import NewTicket from './NewTicket';

export default NewTicket;
